import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class ProductFilters extends ThemeComponent {
    @Prop({default: 0}) scrollPosition!: number;

    @Ref() group!: HTMLElement[];
    @Ref() closeFilters!: HTMLButtonElement[];

    init() {

        // Give initial value for scrollPosition
        this.scrollPosition = 0;

        // Show filter options
        this.handleGroupOpen(this.group);

        // Close filter menu
        this.closeFilterMenu(this.closeFilters);
    }

    private handleGroupOpen(groups: HTMLElement[]) {
        for (const group of groups) {
            this.$listen(group, 'click', (event) => {

                // Do not continue for child clicks
                const clickedElement = event.target as HTMLElement;
                const groupOptions = group.querySelector('.product-filters__group-options');
                if (groupOptions && (clickedElement == groupOptions || groupOptions.contains(clickedElement))) {
                    return;
                }

                for (const sibling of groups) {
                    if (group !== sibling) {
                        sibling.classList.remove('product-filters__group--open');
                    }
                }
                group.classList.toggle('product-filters__group--open');
            });
        }
    }

    private closeFilterMenu(closeFilters: HTMLButtonElement[]) {
        for (const closeFilter of closeFilters) {
            this.$listen(closeFilter, 'click', () => {

                // Only run if filters are active
                if (!document.body.classList.contains('product-filters-active')) {
                    return;
                }

                // Update value for scrollPosition
                const filterToggle = document.querySelector('.filter-toggle .filter-toggle__button');
                if (filterToggle && filterToggle instanceof HTMLElement) {
                    this.scrollPosition = filterToggle.offsetTop;
                }

                // Enable body scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);

                // Body class
                document.body.classList.remove('product-filters-active');

                // Filters class
                this.classList.remove('product-filters--active');
            });
        }
    }
}
